function Indicator() {
  const container = document.querySelector(".js-indicator-container")
  if(container) {
    const lists = container.querySelector(".c-indicator-list")
    const toggle = document.querySelectorAll(".js-step-item")

    const children = lists.childNodes
    let selectedOptions = Array.prototype.filter.call(children, node => { return node.nodeType === Node.ELEMENT_NODE; });
    let init = 12
    const adhtml = document.querySelector('.js-step-number')
    adhtml.innerHTML = `<span>${init}</span>`
    toggle.forEach(element => {
      element.addEventListener("click",(event)=> {
        adhtml.innerHTML = `<span>${init--}</span>`

        event.preventDefault();
        selectedOptions.filter(i => !i.classList.contains("done"))[0].classList.add("done")
      })
      
    });
  }
}

export {Indicator}